import { render, staticRenderFns } from "./BrowseSlatByCtg.vue?vue&type=template&id=50eb44fb&"
import script from "./BrowseSlatByCtg.vue?vue&type=script&lang=js&"
export * from "./BrowseSlatByCtg.vue?vue&type=script&lang=js&"
import style0 from "./BrowseSlatByCtg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports